export default __webpack_public_path__ + "static/media/gng-visivo-acustico-step3.c8a51b0f.svg";